export default __webpack_public_path__ + "static/media/identification-card.f23b7b5e.svg";